import Vue from "vue";

export const state = {
    general_store: {},
    leftPanelOpen: true,
    topLeftIcon:'list',
    country_list: [
        "Afghanistan",
        "Albania",
        "Algeria",
        "Andorra",
        "Angola",
        "Anguilla",
        "Antigua &amp; Barbuda",
        "Argentina",
        "Armenia",
        "Aruba",
        "Australia",
        "Austria",
        "Azerbaijan",
        "Bahamas",
        "Bahrain",
        "Bangladesh",
        "Barbados",
        "Belarus",
        "Belgium",
        "Belize",
        "Benin",
        "Bermuda",
        "Bhutan",
        "Bolivia",
        "Bosnia &amp; Herzegovina",
        "Botswana",
        "Brazil",
        "British Virgin Islands",
        "Brunei",
        "Bulgaria",
        "Burkina Faso",
        "Burundi",
        "Cambodia",
        "Cameroon",
        "Cape Verde",
        "Cayman Islands",
        "Chad",
        "Chile",
        "China",
        "Colombia",
        "Congo",
        "Cook Islands",
        "Costa Rica",
        "Cote D Ivoire",
        "Croatia",
        "Cruise Ship",
        "Cuba",
        "Cyprus",
        "Czech Republic",
        "Denmark",
        "Djibouti",
        "Dominica",
        "Dominican Republic",
        "Ecuador",
        "Egypt",
        "El Salvador",
        "Equatorial Guinea",
        "Estonia",
        "Ethiopia",
        "Falkland Islands",
        "Faroe Islands",
        "Fiji",
        "Finland",
        "France",
        "French Polynesia",
        "French West Indies",
        "Gabon",
        "Gambia",
        "Georgia",
        "Germany",
        "Ghana",
        "Gibraltar",
        "Greece",
        "Greenland",
        "Grenada",
        "Guam",
        "Guatemala",
        "Guernsey",
        "Guinea",
        "Guinea Bissau",
        "Guyana",
        "Haiti",
        "Honduras",
        "Hong Kong",
        "Hungary",
        "Iceland",
        "India",
        "Indonesia",
        "Iran",
        "Iraq",
        "Ireland",
        "Isle of Man",
        "Israel",
        "Italy",
        "Jamaica",
        "Japan",
        "Jersey",
        "Jordan",
        "Kazakhstan",
        "Kenya",
        "Kuwait",
        "Kyrgyz Republic",
        "Laos",
        "Latvia",
        "Lebanon",
        "Lesotho",
        "Liberia",
        "Libya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Macau",
        "Macedonia",
        "Madagascar",
        "Malawi",
        "Malaysia",
        "Maldives",
        "Mali",
        "Malta",
        "Mauritania",
        "Mauritius",
        "Mexico",
        "Moldova",
        "Monaco",
        "Mongolia",
        "Montenegro",
        "Montserrat",
        "Morocco",
        "Mozambique",
        "Namibia",
        "Nepal",
        "Netherlands",
        "Netherlands Antilles",
        "New Caledonia",
        "New Zealand",
        "Nicaragua",
        "Niger",
        "Nigeria",
        "Norway",
        "Oman",
        "Pakistan",
        "Palestine",
        "Panama",
        "Papua New Guinea",
        "Paraguay",
        "Peru",
        "Philippines",
        "Poland",
        "Portugal",
        "Puerto Rico",
        "Qatar",
        "Reunion",
        "Romania",
        "Russia",
        "Rwanda",
        "Saint Pierre &amp; Miquelon",
        "Samoa",
        "San Marino",
        "Satellite",
        "Saudi Arabia",
        "Senegal",
        "Serbia",
        "Seychelles",
        "Sierra Leone",
        "Singapore",
        "Slovakia",
        "Slovenia",
        "South Africa",
        "South Korea",
        "Spain",
        "Sri Lanka",
        "St Kitts &amp; Nevis",
        "St Lucia",
        "St Vincent",
        "St. Lucia",
        "Sudan",
        "Suriname",
        "Swaziland",
        "Sweden",
        "Switzerland",
        "Syria",
        "Taiwan",
        "Tajikistan",
        "Tanzania",
        "Thailand",
        "Timor L'Este",
        "Togo",
        "Tonga",
        "Trinidad &amp; Tobago",
        "Tunisia",
        "Turkey",
        "Turkmenistan",
        "Turks &amp; Caicos",
        "Uganda",
        "Ukraine",
        "United Arab Emirates",
        "United Kingdom",
        "Uruguay",
        "Uzbekistan",
        "Venezuela",
        "Vietnam",
        "Virgin Islands (US)",
        "Yemen",
        "Zambia",
        "Zimbabwe"
    ]
    // user : Medcare.user,
    // roles : Medcare.roles,
};

export const getters = {

    getStore: state => storename => state.general_store[storename],
    getStoreValues: state => storename => state.general_store[storename] ? Object.values(state.general_store[storename]) : null,
    countries: state => state.country_list
    // roles: state => state.roles,
};

export const mutations = {
    topLeftIcon(state, payload) {
       state.topLeftIcon = payload
    },
    toggleLefPanel(state, payload) {
        _log_('toggleLefPanel state.general_store', payload)
        if (payload !== undefined && payload !== null)
            state.leftPanelOpen = payload
        else state.leftPanelOpen = !state.leftPanelOpen
    },
    toggleSelection(state, payload) {

        const context = payload.context ? payload.context : payload.storename;
        if (!state.general_store[context]) {
            Vue.set(state.general_store, context, {})
            Vue.set(state.general_store[context], payload._sk, payload.data)
            _log_('selectInStorage state.general_store 1', payload, state.general_store)
            // state.general_store[context][payload._sk] = payload.data
            return
        }

        if (!payload.data) {
            for (const generalStoreElementKey in state.general_store[context]) {
                let vals = state.general_store[context]
                delete vals[generalStoreElementKey]
                Vue.set(state.general_store, context, JSON.parse(JSON.stringify(vals)))
            }
            return
        }
        _log_('selectInStorage state.general_store 2', payload, state.general_store)
        if (!state.general_store[context][payload._sk]) Vue.set(state.general_store[context], payload._sk, payload.data)
        else {
            let vals = state.general_store[context]
            delete vals[payload._sk]
            Vue.set(state.general_store, context, JSON.parse(JSON.stringify(vals)))
        }
        _log_('selectInStorage state.general_store 3', payload, state.general_store)
        // state.general_store[payload.context] = payload.data; // list.map(m => m['id'].toString());
    },
    setStore(state, payload) {
        Vue.set(state.general_store, payload.context ? payload.context : payload.storename, payload.data);
        // state.general_store[payload.storename] = payload.data;
    },
    clearStore(state, storename) {
        Vue.set(state.general_store, storename, null);
        // state.general_store[payload.storename] = payload.data;
    }
};

export const actions = {};
